export const projectData = {
  name: "Kamdhenu Conquest",
  location: "Kamdhenu Conquest, At Vashi Navi Mumbai",

  bannerImg: [
    "/Images/BANNER/3.jpg",
    "/Images/BANNER/4.jpg",
  ],

  overview: `Position your business at Seafront facing offices at Kamdhenu Conquest a landmark commercial address in the heart of Vashi.
Offering exclusive sea-view “Gold Standard Offices,” this iconic glass facade tower blends elegance with strong investment potential.
Enjoy seamless connectivity via Vashi Flyover, Thane Creek Bridge, Sion-Panvel Highway and proximity to Vashi Railway Station and Navi Mumbai International Airport.
Surrounded by leading corporate hubs like International Infotech Park and Platinum Techno Park, it ensures excellent rental demand and appreciation value.
Premium amenities include a grand entrance lobby, ample parking, CCTV surveillance and 24/7 power backup to enhance business efficiency.
Secure a powerful corporate identity with uninterrupted Arabian Sea views and unmatched infrastructure advantages.
Invest today in a strategic commercial asset designed for growth, prestige and long-term returns.`,

  highlights: [
    "Unobstructed Arabian Sea View",
    "Prime Location at Vashi Seafront",
    "Elegant Glass Façade Commercial Tower",
    "High Rental Yield & Appreciation Potential",
    "Grand Lobby & Extensive Frontage",
    "Ample Parking with CCTV Surveillance",
    "Excellent Connectivity to Mumbai & Navi Mumbai",
  ],

  configurations: [
    { type: "Ascend Offices", area: 475, price: "₹ 1.99 Cr* ++" },
    { type: "Signature Offices", area: 571, price: "₹ 2.38 Cr* ++" },
    { type: "Elite Offices", area: 670, price: "₹ 2.83 Cr* ++" },
    { type: "Crest Offices", area: 1502, price: "₹ 6.45 Cr* ++" },
  ],

  floorPlan: ["/Images/FLOOR PLAN/1.jpg", "/Images/FLOOR PLAN/2.jpg"],

  amenities: [
    { title: "Meeting Room", img: "/Images/AMENITIES/1.jpg" },
    { title: "Umbrella Pool Chair", img: "/Images/AMENITIES/2.jpg" },
    { title: "Outdoor Cinema Hall", img: "/Images/AMENITIES/3.jpg" },
    { title: "Library", img: "/Images/AMENITIES/4.jpg" },
    { title: "Indoor Games", img: "/Images/AMENITIES/5.jpg" },
    { title: "Cafeteria", img: "/Images/AMENITIES/6.jpg" },
  ],
  gallary: [
    "/Images/GALLERY/1.jpg",
    "/Images/GALLERY/2.jpg",
    "/Images/GALLERY/3.jpg",
    "/Images/GALLERY/4.jpg",
    "/Images/GALLERY/5.jpg",
    "/Images/GALLERY/6.jpg",
  ],

  connectivityData: [
    {
      title: "Connectivity",
      items: [
        "Vashi Railway Station - 2 Min",
        "Inorbit Mall - 2 Min",
        "Palm Beach Road - 3 Min",
        "Sion - Panvel Highway - 5 Min",
        "Sanpada Station - 6 Min",
      ],
    },
  ],
};
